import React from "react";
import { useSelector } from "react-redux";
import BeneficialOwnership from "../../../../../../../components/PLCTABS/ApplicationReviewTab/BeneficialOwnership";
const BeneficialOwners = () => {
  const { beneficialOwners, groupedBeneficialOwners } = useSelector(
    (state) => state.companyDashboardSlice
  );
  const isInchangesModule = true;

  return (
    <div className="relative">
      <BeneficialOwnership
        beneficialOwners={beneficialOwners.items}
        groupedBeneficialOwners={groupedBeneficialOwners}
        hideReviewWorkflow
        renderShortTypeOfControl
        showDocumentLabel
        isInchangesModule={isInchangesModule}
      />
    </div>
  );
};

export default BeneficialOwners;
